import { TFunction } from '@sortlist-frontend/translation/ssr';
import { array, number, object, string } from 'yup';

// Form Validation
export const getSchema = (t: TFunction) => {
  const fieldIsRequired = t('common:errors.required');
  const fieldIsNumeric = t('common:errors.numeric');
  const budgetRequired = t('common:errors.onePriceRequired');
  const positiveNumber = t('common:errors.positiveNumber');

  return object().shape({
    expertise_id: number().typeError(fieldIsRequired).required(fieldIsRequired),
    budget: number()
      .transform((cv, ov) => (ov === '' ? undefined : cv))
      .typeError(fieldIsNumeric)
      .moreThan(-1, positiveNumber)
      .required(budgetRequired),
    description: string(),
    skill_tags: array().of(
      object().shape({
        name: string(),
        uuid: string(),
      }),
    ),
  });
};
